import {
  COPY_POST_LINK,
  DELETE_POST_AND_ANSWER,
  EDIT_MY_POST,
} from '../../../languages/en/home';
import { Nullable } from '../../../Utils/common';

const goToPostLink = {
  id: 'goto-post-link',
  prefixIcon: 'post-bw',
  isSelected: false,
  value: 'Go to post',
};

const copyConversationLink = {
  id: 'copy-link',
  prefixIcon: 'Link',
  isSelected: false,
  value: 'Copy conversation link',
};

const copyLinkItem = {
  id: 'copy-link',
  prefixIcon: 'Link',
  isSelected: false,
  value: COPY_POST_LINK,
};

const deleteItem = {
  id: 'delete',
  prefixIcon: 'delete',
  deleteItem: true,
  isSelected: false,
  value: DELETE_POST_AND_ANSWER,
};

const editPostItem = {
  value: EDIT_MY_POST,
  id: 'edit-post',
  prefixIcon: 'edit',
  isSelected: false,
  permissionRequired: true,
};

export const menuItemsWithCopyLink = [
  {
    id: 'feed-post-header-options',
    items: [copyLinkItem],
  },
];

export const menuItemsWithCopyLinkAndDeletePost = [
  {
    id: 'feed-post-header-options',
    items: [copyLinkItem, deleteItem],
  },
];

export const getFeedPostHeaderMenuOptions = (
  isDeletable = false,
  isEditable = false,
  variant: Nullable<string>,
) => {
  if (variant === 'sidebar') {
    const items = [goToPostLink, copyConversationLink];
    return [
      {
        id: 'feed-post-header-options',
        items: items,
      },
    ];
  }

  const menuItems = [copyLinkItem];

  if (isEditable) {
    menuItems.push(editPostItem);
  }
  if (isDeletable) {
    menuItems.push(deleteItem);
  }

  return [
    {
      id: 'feed-post-header-options',
      items: menuItems,
    },
  ];
};
